// extracted by mini-css-extract-plugin
export default {"page":"AccountOwner_page__bcZpD","header":"AccountOwner_header__SVeKj","card":"AccountOwner_card__DfLkn"};